import axios from '../../axios';

const path = 'rules';

const service = {
  async fetchRules(params) {
    return axios({ method: 'get', url: path, params });
  },

  async fetchRule(id, params) {
    return axios({ method: 'get', url: `${path}/${id}`, params });
  },

  async snoozeRules(data) {
    return axios({ method: 'put', url: `${path}/snooze/bulk`, data });
  }
};

export default service;
